import type { QueryParam } from "@ceeferenderer/itg-renderer-sdk";
import { envConfig } from "../config/envConfigs";
import { queryParams } from "../config/queryParams";
import { flowConfig } from "../config/flowConfigs";
import { pick } from "../utils/pick";

const flowParams = flowConfig.queryParams && pick(flowConfig.queryParams, ...(flowConfig.queryParamAllowList || []));

export const queryParam: QueryParam = {
  ...queryParams,
  ...envConfig.queryParams,
  ...flowParams,
};
